jQuery(document).ready(function () {
    // defines in stock and sets limit to how much a user can add to cart
    console.log("Running cart JS");
 
    // This button will increment the value by 0.25 aka 1 stock unit
    $('[data-quantity="plus"]').click(function (e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        var max = $(this).data('max');
      	var step = $(this).data('step');
        var multiStock = $(this).data('multi-stock');
        var itemId = $(this).data('id');
        var inputId = "#updates_" + itemId;
        var updatedQty = "#updated_" + itemId;

        // Get its current value
        var qty_public = (parseInt($(inputId).val() * 100, 10)) / 100;

        // If is not undefined
        if (!isNaN(qty_public)) {
            // If updated value is > than stock, return max stock value.
            if ((qty_public + 1) > max) {
                $(inputId).val(max);
                $(updatedQty).val(max * multiStock);
            } else {
                var qqty = qty_public + step;
                $(inputId).val(qqty);
                $(updatedQty).val(qqty * multiStock);
            }
        } else {
            // Otherwise put a 1 there
            $(inputId).val(1);
            $(updatedQty).val(4);
        }
      
    });


    // This button will decrement the value by 0.25 till minimun cut qty
    $('[data-quantity="minus"]').click(function (e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        var min = $(this).data('min');
      	var step = $(this).data('step');
        var multiStock = $(this).data('multi-stock');
        var itemId = $(this).data('id');
        var inputId = "#updates_" + itemId;
        var updatedQty = "#updated_" + itemId;
        // Get its current value
        var qty_public = (parseInt($(inputId).val() * 100, 10)) / 100;
        // If it isn't undefined or its greater than 1
        if (!isNaN(qty_public) && qty_public > min) {
            // Decrement one
            var qqty = qty_public - step;
            $(inputId).val(qqty);
            $(updatedQty).val(qqty * multiStock);
        } else {
            // Otherwise put a 1 there
            $(inputId).val(min);
            $(updatedQty).val(min * multiStock);
        }
    });
});

/*!
 * jclui - cart page - custom quantity selector
 * minus/plus button validation
 */

$(function () {
    $(".cart-item-qty").change(function () {
        var multiStock = $(this).data('multi-stock');
        var max = $(this).attr('max')/multiStock;
        var min = $(this).attr('min');
        var itemId = $(this).data('item-id');
        var step = $(this).attr('step');
        var updatedQty = "#updated_" + itemId;

        if ($(this).val() > max) {
            $(this).val(max);
            $(updatedQty).val(max * multiStock);
        } else if ($(this).val() < min) {
            $(this).val(min);
            $(updatedQty).val(min * multiStock);
        }
        var qty = Math.ceil($(this).val() * 4) / 4;
        $(this).val(qty);
        $(updatedQty).val(qty * multiStock);
    });
});
